import { useLanguage } from '../contexts/LanguageContext';

export const useLocalizedData = () => {
  const { currentLanguage, getLocalizedField } = useLanguage();

  const getLocalizedValue = (obj, fieldName) => {
    if (!obj) return '';
    
    // Handle different field naming patterns
    const suffix = currentLanguage === 'ar' ? '_ar' : '_en';
    
    // Try with suffix first
    if (obj[`${fieldName}${suffix}`]) {
      return obj[`${fieldName}${suffix}`];
    }
    
    // Try exact field name
    if (obj[fieldName]) {
      return obj[fieldName];
    }
    
    // For specific field mappings
    const fieldMappings = {
      'unit': currentLanguage === 'ar' ? 'Unit' : 'Unit_en',
      'item': currentLanguage === 'ar' ? 'Item' : 'Item_en', 
      'donor': currentLanguage === 'ar' ? 'Donor' : 'Donor_en',
      'category': currentLanguage === 'ar' ? 'category_ar' : 'category_en',
      'subcategory': currentLanguage === 'ar' ? 'subcategory_ar' : 'subcategory_en',
      'type': currentLanguage === 'ar' ? 'type_ar' : 'type_en',
      'source': currentLanguage === 'ar' ? 'source_ar' : 'source_en',
      'for': currentLanguage === 'ar' ? 'for_ar' : 'for_en',
      'entity': currentLanguage === 'ar' ? 'entity_en_ar' : 'entity_en',
      'village': currentLanguage === 'ar' ? 'village_ar' : 'village_en',
    };
    
    if (fieldMappings[fieldName.toLowerCase()]) {
      return obj[fieldMappings[fieldName.toLowerCase()]] || '';
    }
    
    return '';
  };

  const processDataArray = (dataArray, fieldMappings = {}) => {
    if (!Array.isArray(dataArray)) return [];
    
    return dataArray.map(item => ({
      ...item,
      ...Object.keys(fieldMappings).reduce((acc, key) => {
        acc[key] = getLocalizedValue(item, fieldMappings[key]);
        return acc;
      }, {})
    }));
  };

  return {
    getLocalizedValue,
    processDataArray,
    currentLanguage,
    isRTL: currentLanguage === 'ar'
  };
};
